/*
 *
 * Survey reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_SURVEY_WATCHER,
  GET_SURVEY_SUCCESS,
  GET_SURVEY_FAILED,
  GET_DIMENSIONS_QUESTION_WATCHER,
  GET_DIMENSIONS_QUESTION_SUCCESS,
  GET_DIMENSIONS_QUESTION_FAILED,
  GET_QUESTION_TYPES_WATCHER,
  GET_QUESTION_TYPES_SUCCESS,
  GET_QUESTION_TYPES_FAILED,
  GET_QUESTION_WATCHER,
  GET_QUESTION_SUCCESS,
  GET_QUESTION_FAILED,
  CREATE_QUESTION_WATCHER,
  GET_SURVEY_ENPS_WATCHER,
  GET_SURVEY_ENPS_SUCCESS,
  GET_SURVEY_ENPS_FAILED,
  GET_DIMENSION_WATCHER,
  GET_DIMENSION_SUCCESS,
  GET_DIMENSION_FAILED,
  GET_SURVEY_QUALITATIVE_WATCHER,
  GET_SURVEY_QUALITATIVE_SUCCESS,
  GET_SURVEY_QUALITATIVE_FAILED,
  GET_CONFIG_SURVEY_WATCHER,
  GET_CONFIG_SURVEY_SUCCESS,
  GET_CONFIG_SURVEY_FAILED,
  GET_QUESTIONS_WATCHER,
  GET_QUESTIONS_SUCCESS,
  GET_QUESTIONS_FAILED,
  UPLOAD_BG_IMAGE_WATCHER,
  UPLOAD_BG_IMAGE_SUCCESS,
  UPLOAD_BG_IMAGE_FAILED,
  UPLOAD_LOGO_WATCHER,
  UPLOAD_LOGO_SUCCESS,
  UPLOAD_LOGO_FAILED,
  DELETE_ALL_QUESTIONS_WATCHER,
  DELETE_ALL_QUESTIONS_SUCCESS,
  DELETE_ALL_QUESTIONS_FAILED,
  CREATE_QUESTION_SUCCESS,
  CREATE_QUESTION_FAILED,
  UPDATE_QUESTION_SUCCESS,
  UPDATE_QUESTION_FAILED,
  UPDATE_QUESTION_WATCHER,
  GET_QUESTION_MULTIPLE_CHOICE_WATCHER,
  GET_QUESTION_MULTIPLE_CHOICE_SUCCESS,
  GET_QUESTION_MULTIPLE_CHOICE_FAILED,
  GET_SEGMENTS_SUCCESS,
  GET_SEGMENTS_FAILED,
  GET_SEGMENTS_WATCHER,
  GET_SURVEY_TYPES_WATCHER,
  GET_SURVEY_TYPES_SUCCESS,
  GET_SURVEY_TYPES_FAILED,
  GET_SCOPE_TYPES_WATCHER,
  GET_SCOPE_TYPES_SUCCESS,
  GET_SCOPE_TYPES_FAILED,
} from "./constants"

export const initialState = fromJS({
  survey: [],
  engagement: [],
  surveyName: "",
  isLoadingSurvey: true,
  dimensionsQuestion: [],
  isLoadingDimensionsQuestion: true,
  questionTypes: [],
  isLoadingQuestionTypes: true,
  question: {},
  isLoadingQuestion: false,
  surveyEnps: [],
  isLoadingSurveyEnps: true,
  dimension: {},
  isLoadingDimension: true,
  surveyQualitative: [],
  isLoadingSurveyQualitative: true,
  isLoadingDeleteAllQuestions: true,
  configSurvey: {},
  isLoadingConfigSurvey: true,
  questions: [],
  isLoadingQuestions: true,
  uploadBgImage: {},
  isLoadingUploadBgImage: true,
  uploadLogo: "",
  isLoadingUploadLogo: true,
  isLoadingCreateQuestion: false,
  isErrorCreateQuestion: false,
  listQuestionMultipleChoice: [],
  segments: [],
  isLoadingSegments: true,
  surveyTypes: [],
  isLoadingSurveyTypes: true,
  scopeTypes: [],
  isLoadingScopeTypes: true,
})

function surveyReducer(state = initialState, action) {
  switch (action.type) {
    case UPLOAD_LOGO_WATCHER:
      return state.set("uploadLogo", "").set("isLoadingUploadLogo", true)
    case UPLOAD_LOGO_SUCCESS:
      return state
        .set("uploadLogo", action.payload)
        .set("isLoadingUploadLogo", false)
    case UPLOAD_LOGO_FAILED:
      return state.set("uploadLogo", "").set("isLoadingUploadLogo", false)

    case UPLOAD_BG_IMAGE_WATCHER:
      return (
        state
          // .set('uploadBgImage', {})
          .set("isLoadingUploadBgImage", true)
      )
    case UPLOAD_BG_IMAGE_SUCCESS:
      return state
        .set("uploadBgImage", action.payload)
        .set("isLoadingUploadBgImage", false)
    case UPLOAD_BG_IMAGE_FAILED:
      return (
        state
          // .set('uploadBgImage', {})
          .set("isLoadingUploadBgImage", false)
      )

    case GET_QUESTIONS_WATCHER:
      return state.set("questions", []).set("isLoadingQuestions", true)
    case GET_QUESTIONS_SUCCESS:
      return state
        .set("questions", action.payload)
        .set("isLoadingQuestions", false)
    case GET_QUESTIONS_FAILED:
      return state.set("questions", []).set("isLoadingQuestions", false)

    case GET_CONFIG_SURVEY_WATCHER:
      return state.set("configSurvey", {}).set("isLoadingConfigSurvey", true)
    case GET_CONFIG_SURVEY_SUCCESS:
      return state
        .set("configSurvey", action.payload)
        .set("isLoadingConfigSurvey", false)
    case GET_CONFIG_SURVEY_FAILED:
      return state.set("configSurvey", {}).set("isLoadingConfigSurvey", false)

    case GET_DIMENSION_WATCHER:
      return state.set("dimension", []).set("isLoadingDimension", true)
    case GET_DIMENSION_SUCCESS:
      return state
        .set("dimension", action.payload)
        .set("isLoadingDimension", false)
    case GET_DIMENSION_FAILED:
      return state.set("dimension", []).set("isLoadingDimension", false)

    case GET_SURVEY_ENPS_WATCHER:
      return (
        state
          // .set('surveyEnps', {})
          .set("isLoadingSurveyEnps", true)
      )
    case GET_SURVEY_ENPS_SUCCESS:
      return state
        .set("surveyEnps", action.payload)
        .set("isLoadingSurveyEnps", false)
    case GET_SURVEY_ENPS_FAILED:
      return state.set("surveyEnps", {}).set("isLoadingSurveyEnps", false)

    case GET_SURVEY_QUALITATIVE_WATCHER:
      return (
        state
          // .set('surveyQualitative', {})
          .set("isLoadingSurveyQualitative", true)
      )
    case GET_SURVEY_QUALITATIVE_SUCCESS:
      return state
        .set("surveyQualitative", action.payload)
        .set("isLoadingSurveyQualitative", false)
    case GET_SURVEY_QUALITATIVE_FAILED:
      return state
        .set("surveyQualitative", {})
        .set("isLoadingSurveyQualitative", false)

    case CREATE_QUESTION_WATCHER:
      return state.set("isLoadingCreateQuestion", true)

    case CREATE_QUESTION_SUCCESS:
      return state
        .set("isLoadingCreateQuestion", false)
        .set("isErrorCreateQuestion", false)

    case CREATE_QUESTION_FAILED:
      return state
        .set("isLoadingCreateQuestion", false)
        .set("isErrorCreateQuestion", true)

    case UPDATE_QUESTION_WATCHER:
      return state.set("isLoadingCreateQuestion", true)

    case UPDATE_QUESTION_SUCCESS:
      return state
        .set("isLoadingCreateQuestion", false)
        .set("isErrorCreateQuestion", false)

    case UPDATE_QUESTION_FAILED:
      return state
        .set("isLoadingCreateQuestion", false)
        .set("isErrorCreateQuestion", true)

    case GET_QUESTION_WATCHER:
      return state.set("question", {}).set("isLoadingQuestion", true)
    case GET_QUESTION_SUCCESS:
      return state
        .set("question", action.payload)
        .set("isLoadingQuestion", false)
    case GET_QUESTION_FAILED:
      return state.set("question", {}).set("isLoadingQuestion", false)

    case GET_QUESTION_TYPES_WATCHER:
      return state.set("questionTypes", []).set("isLoadingQuestionTypes", true)
    case GET_QUESTION_TYPES_SUCCESS:
      return state
        .set("questionTypes", action.payload)
        .set("isLoadingQuestionTypes", false)
    case GET_QUESTION_TYPES_FAILED:
      return state.set("questionTypes", []).set("isLoadingQuestionTypes", false)

    case GET_DIMENSIONS_QUESTION_WATCHER:
      return state
        .set("dimensionsQuestion", [])
        .set("isLoadingDimensionsQuestion", true)
    case GET_DIMENSIONS_QUESTION_SUCCESS:
      return state
        .set("dimensionsQuestion", action.payload)
        .set("isLoadingDimensionsQuestion", false)
    case GET_DIMENSIONS_QUESTION_FAILED:
      return state
        .set("dimensionsQuestion", [])
        .set("isLoadingDimensionsQuestion", false)

    case GET_SURVEY_WATCHER:
      return (
        state
          // .set('survey', [])
          // .set('surveyName', '')
          .set("isLoadingSurvey", true)
      )
    case GET_SURVEY_SUCCESS:
      return state
        .set("engagement", action.payload.engagement)
        .set("survey", action.payload.summary)
        .set("surveyName", action.payload.survey)
        .set("hasLikertQuestions", action.payload.hasLikertQuestions)
        .set("isLoadingSurvey", false)
    case GET_SURVEY_FAILED:
      return state.set("survey", []).set("isLoadingSurvey", false)

    case DELETE_ALL_QUESTIONS_WATCHER:
      return state.set("isLoadingDeleteAllQuestions", true)
    case DELETE_ALL_QUESTIONS_SUCCESS:
      return state
        .set("surveyEnps", {})
        .set("surveyQualitative", {})
        .set("dimensionsQuestion", [])
        .set("questionTypes", [])
        .set("questions", [])
        .set("survey", [])
        .set("isLoadingDeleteAllQuestions", false)
    case DELETE_ALL_QUESTIONS_FAILED:
      return state.set("isLoadingDeleteAllQuestions", false)

    /* case GET_QUESTION_MULTIPLE_CHOICE_WATCHER:
      return state.set("listQuestionMultipleChoice", []) */
    case GET_QUESTION_MULTIPLE_CHOICE_SUCCESS:
      return state.set("listQuestionMultipleChoice", action.payload)
    case GET_QUESTION_MULTIPLE_CHOICE_FAILED:
      return state.set("listQuestionMultipleChoice", [])
    case GET_SEGMENTS_WATCHER:
      return state.set("segments", []).set("isLoadingSegments", true)
    case GET_SEGMENTS_SUCCESS:
      return state
        .set("segments", action.payload)
        .set("isLoadingSegments", false)
    case GET_SEGMENTS_FAILED:
      return state.set("segments", []).set("isLoadingSegments", false)

    case GET_SURVEY_TYPES_WATCHER:
      return state.set("surveyTypes", []).set("isLoadingSurveyTypes", true)
    case GET_SURVEY_TYPES_SUCCESS:
      return state
        .set("surveyTypes", action.payload)
        .set("isLoadingSurveyTypes", false)
    case GET_SURVEY_TYPES_FAILED:
      return state.set("surveyTypes", []).set("isLoadingSurveyTypes", false)

    case GET_SCOPE_TYPES_WATCHER:
      return state.set("scopeTypes", []).set("isLoadingScopeTypes", true)
    case GET_SCOPE_TYPES_SUCCESS:
      return state
        .set("scopeTypes", action.payload)
        .set("isLoadingScopeTypes", false)
    case GET_SCOPE_TYPES_FAILED:
      return state.set("scopeTypes", []).set("isLoadingScopeTypes", false)
    default:
      return state
  }
}

export default surveyReducer
